import { useInfiniteQuery } from '@tanstack/react-query';

import { QUERY_KEY } from '~common';
import { postPaymentRequest } from '~services';
import { inMemoryJWTService } from '~services/jwt.service';
import { InstitutionListResponse } from '~types';

const DEFAULT_PAGE_SIZE = 20;

type InstitutionCursor = {
  cursorName: string;
  cursorUuid: string;
};

export const useQueryListInstitutions = (search?: string) => {
  return useInfiniteQuery<InstitutionListResponse>(
    [QUERY_KEY.LIST_CAMPUS_INSTITUTIONS, search],
    ({ pageParam }: { pageParam?: InstitutionCursor }) => {
      return postPaymentRequest({
        path: 'api/campus-card/institution/list',
        data: {
          search: search || null,
          uuids: null,
          size: DEFAULT_PAGE_SIZE,
          cursorName: pageParam?.cursorName ?? null,
          cursorUuid: pageParam?.cursorUuid ?? null,
        },
      }).then((res) => res.data);
    },
    {
      // Both cursors come back null only on the final page (backend contract);
      // they must be sent together to fetch the next page.
      getNextPageParam: (lastPage) =>
        lastPage.lastCursorName && lastPage.lastCursorUuid
          ? {
              cursorName: lastPage.lastCursorName,
              cursorUuid: lastPage.lastCursorUuid,
            }
          : undefined,
      enabled: !!inMemoryJWTService.getCurrentToken(),
      keepPreviousData: true,
    },
  );
};
